import React from "react";
import { useNavigate } from "react-router-dom";
import { styled } from "styled-components";

import LogoLoca from "../../styles/images/logo_loca_big.svg";
import LogoMobiligent from "../../styles/images/logo_mobiligent_big.svg";
import LogoD2e from "../../styles/images/logo_d2e_big.svg";
import LogoBoatrang from "../../styles/images/logo_boatrang_big.svg";
import LogoGreego from "../../styles/images/logo_greego_big.svg";
import LogoTau from "../../styles/images/logo_tau_big.svg";
import { ReactComponent as IcoArrow } from "../../styles/images/ico_arrow.svg";

import { TextDiv } from "../../styles/Common";

import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
const CompanyList = (props) => {
  const { clickDisabled, data, page } = props;
  const navigate = useNavigate();
  const settings = {
    dots: false,
    infinite: true,
    slidesToShow: 1,
    slidesToScroll: 1,
    autoplay: true,
    speed: 1500,
    autoplaySpeed: 0,
    cssEase: "linear",
  };
  return page == "introducePage" ? (
    // <ListWrap>
    //   <ul>
    //     {data.list.map((logo, index) => (
    //       <li key={index} className="pointer">
    //         <List
    //           onClick={
    //             clickDisabled
    //               ? () => {
    //                   navigate("/introduce/partners/detail", {
    //                     state: { target: logo },
    //                   });
    //                 }
    //               : () => {
    //                   return;
    //                 }
    //           }
    //         >
    //           <LogoWrap>
    //             <img src={logo.image} alt={logo.alt} />
    //           </LogoWrap>
    //         </List>
    //       </li>
    //     ))}
    //   </ul>
    // </ListWrap>

    <StyledSliderWrap className="slider-container">
      <StyledSlider {...settings}>
        {data.list.map((logo, index) => (
          <div key={index}>
            <article>
              <SliderLogoWrap>
                <img src={logo.image} alt={logo.alt} />
              </SliderLogoWrap>
              <SliderText>
                <h4>{logo.name}</h4>
              </SliderText>
            </article>
          </div>
        ))}
      </StyledSlider>
    </StyledSliderWrap>
  ) : (
    <ListWrap>
      <ul>
        {data.list.map((logo, index) => (
          <li key={index} className="pointer">
            <List
              onClick={
                clickDisabled
                  ? () => {
                      navigate("/introduce/partners/detail", {
                        state: { target: logo },
                      });
                    }
                  : () => {
                      return;
                    }
              }
            >
              <LogoWrap>
                <img src={logo.image} alt={logo.alt} />
              </LogoWrap>
              <Text>
                <h4>{logo.name}</h4>

                <IcoArrow
                // onClick={
                //   clickDisabled
                //     ? () => {
                //         navigate("/introduce/partners/detail", {
                //           state: { target: logo },
                //         });
                //       }
                //     : () => {
                //         return;
                //       }
                // }
                />
              </Text>
            </List>
          </li>
        ))}
      </ul>
    </ListWrap>
  );
};

export default CompanyList;
const baseMarginTop = "1.4rem";

// const ListWrap = styled.div`
//   text-align: left;

//   ul {
//     display: flex;
//     justify-content: space-between;
//     flex-wrap: wrap;
//   }

//   li {
//     width: 50%;
//     margin-top: ${baseMarginTop};
//     text-align: center;
//     &:nth-of-type(even) > div {
//       margin-left: 0.8rem;
//     }
//   }
// `;

// const List = styled.div`
//   min-width: 7.2rem;
//   width: calc(100% - 0.8rem);

//   @media screen and (max-width: 375px) {
//     min-width: 0;
//   }
// `;

// const LogoWrap = styled.div`
//   width: 100%;
//   height: 7.2rem;
//   min-height: 7.2rem;
//   border-radius: 10px;
//   background: ${({ theme }) => theme.color.white};
//   box-shadow: 0px 4px 12px 0px rgba(0, 0, 0, 0.05);
//   display: flex;
//   justify-content: center;
//   align-items: center;

//   img {
//     max-width: 70%;
//     max-height: 100%;
//   }
const ListWrap = styled.div`
  text-align: left;

  ul {
    display: flex;
    justify-content: space-between;
    flex-wrap: wrap;
    /* margin-top: ${baseMarginTop}; */
  }

  li {
    width: 100%;
    margin-top: ${baseMarginTop};
    text-align: center;
    /* &:nth-of-type(even) > div {
      margin-left: 0.8rem;
    } */
  }
`;

const List = styled.div`
  min-width: 7.2rem;
  width: 100%;
  min-height: 10rem;
  border-radius: 10px;
  background: ${({ theme }) => theme.color.white};
  box-shadow: 0px 4px 12px 0px rgba(0, 0, 0, 0.05);
  display: flex;
  justify-content: start;
  align-items: center;
  padding: 2rem 2rem;
  @media screen and (max-width: 375px) {
    min-width: 0;
  }
`;

const LogoWrap = styled.div`
  /* box-shadow: 0px 0px 8px 0px rgba(0, 0, 0, 0.06); */
  width: 9rem;
  height: 9rem;
  border-radius: 50%;
  overflow: hidden;
  min-height: 8rem;
  display: flex;
  justify-content: center;
  align-items: center;
  margin-right: 2rem;

  img {
    width: 90%;
    max-width: 100%;
    max-height: 100%;
  }
`;
const Text = styled.div`
  width: 60%;
  height: 7.2rem;
  min-height: 7.2rem;
  display: flex;
  justify-content: space-between;
  align-items: center;
`;
const StyledSliderWrap = styled.div`
  margin-top: 2rem;
  padding: 2rem 0;
  width: calc(100vw - 5.2rem);
`;
const StyledSlider = styled(Slider)`
  article {
    align-items: center;
    display: flex;
    flex-direction: column;
    justify-content: center;
  }
`;
const SliderLogoWrap = styled(LogoWrap)`
  margin-right: 0;
  background-color: #fff;
  text-align: center;
`;
const SliderText = styled(Text)`
  justify-content: center;
`;
